<template>
  <div v-if="hasFiles">
    <input type="hidden" name="files" />
    <div v-for="({ localId, icon, name, isRemoved }, i) in files" :key="i" class="m-t-5">
      <input v-if="!isRemoved" :value="localId" type="hidden" name="files[]" />
      <a :class="{ 'line-through faded': isRemoved }" :href="`/files/${localId}`" target="_blank">
        <i v-if="icon" :style="{ color: icon.color }" :class="`fa ${icon.icon}`" />
        <i v-else class="fa fa-file" />
        {{ name }}
        <i v-if="!isRemoved" class="zmdi zmdi-download c-gray m-l-5" />
      </a>
      <i
        v-if="!isRemoved"
        class="zmdi zmdi-delete c-gray m-l-10 pointer"
        @click="toggleFileDeletion(i)"
      />
      <a v-if="isRemoved" class="pointer small m-l-10" @click="toggleFileDeletion(i)">
        {{ $t('Undo') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    files: { type: Array, default: () => [] },
    edit: { type: Boolean, default: false },
  },
  computed: {
    hasFiles() {
      return this.files.length > 0
    },
  },
  methods: {
    toggleFileDeletion(id) {
      this.$emit('toggleFileDeletion', id)
    },
  },
}
</script>

<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
